<script module lang="ts">
  // ContrastBadge renders WCAG grades (AAA / AA / AA Large / Fail) with
  // specific color palettes. Each grade has its own visual treatment and
  // any one of them breaking silently would hide accessibility issues in
  // the design editor — so every grade gets a pinned story.
  import { defineMeta } from '@storybook/addon-svelte-csf'
  import ContrastBadge from './ContrastBadge.svelte'

  const { Story } = defineMeta({
    component: ContrastBadge,
    title: 'Components/ProfileEditor/ContrastBadge',
    tags: ['autodocs'],
    parameters: { layout: 'centered' },
  })
</script>

<!--
  ─── WCAG grade matrix ─────────────────────────────────────────────
  Foreground / background combinations chosen to hit each grade exactly.
-->

<Story name="Grade · AAA (black on white)">
  {#snippet template()}
    <div style="padding: 32px;">
      <ContrastBadge foreground="#000000" background="#ffffff" />
    </div>
  {/snippet}
</Story>

<Story name="Grade · AA (dark slate on white)">
  {#snippet template()}
    <div style="padding: 32px;">
      <ContrastBadge foreground="#475569" background="#ffffff" />
    </div>
  {/snippet}
</Story>

<Story name="Grade · AA Large (medium on white, large text)">
  {#snippet template()}
    <div style="padding: 32px;">
      <ContrastBadge foreground="#94a3b8" background="#ffffff" largeText={true} />
    </div>
  {/snippet}
</Story>

<Story name="Grade · Fail (light on white)">
  {#snippet template()}
    <div style="padding: 32px;">
      <ContrastBadge foreground="#e2e8f0" background="#ffffff" />
    </div>
  {/snippet}
</Story>

<!--
  ─── Edge cases ────────────────────────────────────────────────────
-->

<Story name="Label prefix · 'Text'">
  {#snippet template()}
    <div style="padding: 32px;">
      <ContrastBadge foreground="#1e293b" background="#ffffff" label="Text" />
    </div>
  {/snippet}
</Story>

<Story name="Note caveat · gradient background">
  {#snippet template()}
    <div style="padding: 32px;">
      <ContrastBadge
        foreground="#ffffff"
        background="#1d4ed8"
        note="그라디언트 배경은 대표색 기준 계산"
      />
    </div>
  {/snippet}
</Story>

<Story name="Null foreground · unknown state">
  {#snippet template()}
    <div style="padding: 32px;">
      <ContrastBadge foreground={null} background="#ffffff" />
    </div>
  {/snippet}
</Story>

<!--
  ─── Real profile editor pairings ──────────────────────────────────
  The exact color combos the design editor uses when the user opens
  the Text / Buttons pickers. Pins regression when a theme default
  changes.
-->

<Story name="Preset · Clean (title on white)">
  {#snippet template()}
    <div style="padding: 32px;">
      <ContrastBadge foreground="#1E293B" background="#FFFFFF" largeText={true} />
    </div>
  {/snippet}
</Story>

<Story name="Preset · Cafe latte (dark brown on cream card)">
  {#snippet template()}
    <div style="padding: 32px;">
      <ContrastBadge foreground="#2D1810" background="#FFF8F0" />
    </div>
  {/snippet}
</Story>

<Story name="Preset · Dark (white on near-black)" parameters={{ backgrounds: { default: 'dark' } }}>
  {#snippet template()}
    <div style="padding: 32px;">
      <ContrastBadge foreground="#F5F5F5" background="#0F0F0F" />
    </div>
  {/snippet}
</Story>
